import { render } from "./CertificateGeneratorFormBulk.vue?vue&type=template&id=cc1d1a76"
import script from "./CertificateGeneratorFormBulk.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorFormBulk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__